// extracted by mini-css-extract-plugin
export var actionText = "_o5-4";
export var container = "_o5-0";
export var leftSection = "_o5-1";
export var rightSection = "_o5-2";
export var settingsButton = "_o5-6";
export var settingsIcon = "_o5-7";
export var shortcut = "_o5-5";
export var shortcutGroup = "_o5-3";